import { post, postpro } from '../index';


export const verifyBrandName = data => {
    return postpro('/brands/verify-brand-name', data, false);
  };